import React from 'react'

interface CellProps extends Omit<React.HTMLAttributes<HTMLTableCellElement>, 'className'> {
  children?: React.ReactNode;
}

export function Cell ({ children, ...props }: CellProps) {
  return (
    <td
      {...props}
      className='p-4 border-b group-last/row:border-b-0 border-gray-200'
    >
      {children}
    </td>
  )
}

Cell.displayName = 'PlanTable.Cell'
